// extracted by mini-css-extract-plugin
module.exports = {"root":"affiliate_root__2SLO7"};